import React from 'react';
import ReactDOM from 'react-dom/client';
import AppConsole from './AppConsole.tsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppConsole />
  </React.StrictMode>
);
